import createReducer from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';
import { combineReducers } from 'redux';

const data = createReducer(
  {
    code: '',
    incorrect: false,
    message: ''
  },
  {
    [ActionTypes.SHAREABLE_CODE_INPUT]: (state, { payload }) => {
      return { ...state, code: payload };
    },
    [ActionTypes.SHAREABLE_CODE_INCORRECT]: (state, { payload }) => {
      return { ...state, incorrect: payload };
    },
    [ActionTypes.SHAREABLE_CODE_MESSAGE]: (state, { payload }) => {
      return { ...state, message: payload };
    },

    [ActionTypes.SHAREABLE_QUERY]: (state, { payload }) => {
      return { ...state, code: payload };
    }
  }
);

export default combineReducers({
  data
});
